<template lang="html">
  <div style="overflow:auto;max-height:500px;" class="pa-1">
    <template v-if="!loading">
      <v-card
        outlined
        v-for="item in items"
        :key="item.id"
        class="laporan-item mb-3"
        :style="{borderLeft: '4px solid ' + $vuetify.theme.currentTheme[getStatus(item).color]}"
      >
        <v-card-text class="pb-1">
          <div class="d-flex align-center flex-wrap">
            <v-icon small left>mdi-clock-outline</v-icon>
            <span class="font-weight-bold laporan-item__waktu">
              {{item.jam_mulai | addZero}}:{{item.menit_mulai | addZero}} &ndash; {{item.jam_selesai | addZero}}:{{item.menit_selesai | addZero}}
            </span>
            <v-spacer></v-spacer>
            <v-chip x-small outlined class="mr-1">{{item.jenis == 'kinerja' ? 'Utama' : 'Tambahan'}}</v-chip>
            <v-chip x-small :color="getStatus(item).color" text-color="white">
              <v-icon x-small left>{{getStatus(item).icon}}</v-icon>
              {{getStatus(item).text}}
            </v-chip>
          </div>

          <div class="laporan-item__nama font-weight-medium mt-2">{{item.nama_aktifitas}}</div>
          <div class="caption grey--text text--darken-1">Volume {{item.volume}} x {{item.satuan_output}}</div>

          <p class="laporan-item__keterangan mt-2 mb-0">{{item.keterangan}}</p>

          <div v-if="item.nip_verifikator" class="caption grey--text text--darken-1 mt-2">
            <v-icon x-small left>mdi-account-check-outline</v-icon>
            Verifikator : <span class="font-weight-medium">{{item.nip_verifikator}}</span>
          </div>

          <v-alert
            v-if="item.keterangan_validasi"
            dense
            text
            :color="getStatus(item).color"
            class="caption mt-2 mb-0"
          >
            <span class="font-weight-medium">Keterangan Validasi :</span> {{item.keterangan_validasi}}
          </v-alert>
        </v-card-text>

        <v-card-actions v-if="!item.status" class="pt-0">
          <v-spacer></v-spacer>
          <v-btn small text color="primary" @click="$emit('edit', item)"><v-icon small left>mdi-pencil</v-icon> Ubah</v-btn>
          <confirm-btn title="Hapus Laporan" :content="'Hapus aktivitas ini ?'" @on-agree="$emit('delete', item)" :btnProps="{'name':'hapus', color:'error', small:true, icon:'mdi-delete', class:{'my-1':true,'ml-1':true}}"></confirm-btn>
        </v-card-actions>
      </v-card>

      <div v-if="items.length == 0" class="d-flex align-center flex-column py-8">
        <v-icon size="56" color="grey lighten-1">mdi-calendar-blank-outline</v-icon>
        <p class="paragraph mt-3 mb-4">Belum ada laporan pada tanggal ini</p>
        <v-btn v-if="canReport" small class="success" @click="$emit('lapor')"><v-icon small left>mdi-plus</v-icon> Lapor aktivitas</v-btn>
      </div>
    </template>
    <template v-else>
      <v-skeleton-loader class="mb-3" v-for="i in [1,2]" :key="i"
          type="article, actions"
      ></v-skeleton-loader>
    </template>
  </div>
</template>

<script>
import ConfirmBtn from '@/components/base/ConfirmBtn'
export default {
  components:{
    ConfirmBtn
  },
  props:{
    items:{
      type:Array,
      default:() => []
    },
    loading:Boolean,
    canReport:Boolean,
  },
  filters:{
    addZero:function(value){
      if (value*1 < 10){
        return '0'+value
      }
      return value
    }
  },
  methods:{
    getStatus(item){
      if (item.status == 'valid'){
        return {text:'Disetujui', color:'success', icon:'mdi-check'}
      } else if (item.status == 'invalid'){
        return {text:'Ditolak', color:'error', icon:'mdi-close'}
      }
      return {text:'Diproses', color:'info', icon:'mdi-timer-sand'}
    }
  }
}
</script>

<style lang="scss" scoped>
  .laporan-item{
    &__waktu{
      font-size: 14px;
    }
    &__nama{
      font-size: 14px;
      line-height: 1.3;
    }
    &__keterangan{
      font-size: 12px;
      white-space: pre-line;
      overflow-wrap: anywhere;
    }
  }
</style>
